import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer wow fadeInUp animated" data-wow-delay="900ms">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="footer-about">
                <a href="#" className="footer-about-logo">
                  <img src="img/logo.png" alt="Logo" />
                </a>
                <div className="footer-description">
                  {/* <p>
                    Lorem ipsum dolor sit amet, anim id est laborum. Sed ut
                    perspconsectetur, adipisci vam aliquam qua.
                  </p> */}
                </div>
                <div className="wb-social-media">
                  <a href="#" className="bh">
                    <i className="fa fa-behance"></i>
                  </a>
                  <a href="#" className="fb">
                    <i className="fa fa-facebook-official"></i>
                  </a>
                  <a href="#" className="db">
                    <i className="fa fa-dribbble"></i>
                  </a>
                  <a href="#" className="gp">
                    <i className="fa fa-google-plus"></i>
                  </a>
                  <a href="#" className="vn">
                    <i className="fa fa-vine"></i>
                  </a>
                  <a href="#" className="yt">
                    <i className="fa fa-youtube-play"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 footer-view-controller">
              <div className="footer-nav">
                <h6 className="footer-subtitle active-color">Footer Menu</h6>
                <ul>
                  <li>
                    <a href="/"> Home </a>
                  </li>
                  <li>
                    <a href="/compareProducts">Comparison Product </a>
                  </li>
                  <li>
                    <a href="products">Mobiles </a>
                  </li>
                  {/* <li>
                    <a href="review-left-sidebar.html">Reviews</a>
                  </li>
                  <li>
                    <a href="blog-four-grid-left-sidebar.html">Blog</a>
                  </li> */}
                </ul>
              </div>
            </div>
            {/* <div className="col-md-3 footer-view-controller">
              <div className="footer-nav">
                <div className="stores-list">
                  <h6 className="footer-subtitle">Top Stores</h6>
                  <ul>
                    <li>
                      <a href="shop-left-sidebar.html">Affiliate Market 1</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
            {/* <div className="col-md-2 footer-view-controller">
              <div className="footer-nav">
                <h6 className="footer-subtitle">Need Help ?</h6>
                <ul>
                  <li>
                    <a href="#">Getting Started</a>
                  </li>
                  <li>
                    <Link className="link" to="/contactUs">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <a href="#">FAQ's</a>
                  </li>
                  <li>
                    <a href="#">Press</a>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-md-2 footer-view-controller">
              <div className="footer-nav">
                <h6 className="footer-subtitle">About</h6>
                <ul>
                  <li>
                    <Link className="link" to="#">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <a href="#">Return Policy</a>
                  </li>
                  {/* <li>
                    <a href="conditions.html">Order &#38; Return</a>
                  </li> */}
                  <li>
                    <a href="#">Terms &#38; Conditions</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div id="ad-300"></div>
    </>
  );
};

export default Footer;
